import React from 'react';
import './VisionMission.css';
import { useLanguage } from '../context/LanguageContext';

const VisionMission = () => {
  const { t } = useLanguage();

  return (
    <section id="vizyon" className="vm-section">
      <div className="section-header">
        <div className="section-badge">
          <i className="fa-solid fa-compass"></i>
          <span>{t('visionMission.badge')}</span>
        </div>
        <h2 className="section-title">{t('visionMission.title')}</h2>
        <p className="section-subtitle">{t('visionMission.subtitle')}</p>
      </div>

      <div className="vm-grid">
        {/* Vision Card */}
        <div className="vm-card vision-card">
          <div className="vm-card-header">
            <div className="vm-icon-box">
              <i className="fa-solid fa-eye"></i>
            </div>
            <span className="vm-tag">{t('visionMission.visionTitle')}</span>
          </div>
          <h3>{t('visionMission.visionTitle')}</h3>
          <p>{t('visionMission.visionDesc')}</p>
          <ul className="vm-bullets">
            <li><i className="fa-solid fa-circle-check"></i> {t('visionMission.f1')}</li>
            <li><i className="fa-solid fa-circle-check"></i> {t('visionMission.f2')}</li>
          </ul>
        </div>

        {/* Mission Card */}
        <div className="vm-card mission-card">
          <div className="vm-card-header">
            <div className="vm-icon-box">
              <i className="fa-solid fa-bullseye"></i>
            </div>
            <span className="vm-tag">{t('visionMission.missionTitle')}</span>
          </div>
          <h3>{t('visionMission.missionTitle')}</h3>
          <p>{t('visionMission.missionDesc')}</p>
          <ul className="vm-bullets">
            <li><i className="fa-solid fa-circle-check"></i> {t('visionMission.f3')}</li>
            <li><i className="fa-solid fa-circle-check"></i> {t('visionMission.f4')}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
